// React key of the "Not assigned" row or column; value codes are numeric strings.
export const UNASSIGNED_AXIS_KEY = "unassigned";

// The minimum width keeps names readable; a narrow modal scrolls the table sideways instead.
export const COLUMN_TRACK = "minmax(280px, 1fr)";
